import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { RequestManagementService } from '../services/request-management.service';
import { UserService } from '../services/user.service';
import 'rxjs/add/operator/map';
import { ParameterModel } from '../_models/_index';

@Injectable()
export class ParameterService {

    constructor(private requestManagement: RequestManagementService,
        private userService: UserService) {
    }

    public getParameters(): Promise<ParameterModel[]> {
        return this.requestManagement.callGetRequest('parameters/get',null).map((response: Response) => {
            return <ParameterModel[]>response.json();
        }).toPromise();
    }

    public editParameter(parameter: ParameterModel): Promise<ParameterModel> {
        parameter.updatorID = this.userService.getCurrentUser().id;
        return this.requestManagement.callPostRequest('parameters/edit', parameter).map((response: Response) => {
            return <ParameterModel>response.json();
        }).toPromise();
    }

}



// WEBPACK FOOTER //
// ./src/app/services/parameter.service.ts